import React, { FunctionComponent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { EnrollmentFormProps } from "./../EnrollmentFormPage";
import { FocusableHeader } from "../../../components";
import {
  CONSTANTS as C,
  makePlanDisplayId,
  useTranslate,
  sendTealiumEvent,
} from "../../../helpers";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { AppContext } from "../../../app/store";
import { printPage } from "../../../components/PrintButton";
import { addProtocolToUrl } from "../../../helpers/objectUtilities";
import routes from "../../../app/routes";

const Enrolled: FunctionComponent<EnrollmentFormProps> = ({
  enrollData,
  plan,
}) => {
  const t = useTranslate();
  const {
    state: { viewMedigap, language },
  } = useContext(AppContext);

  return (
    <div>
      <FocusableHeader
        className="EnrollmentFormPage__header"
        text={t("enrollment_form.application_received")}
      />
      <div className="ds-u-measure--wide">
        {plan && (
          <section>
            <div className="EnrolledProcessedBy">
              <FormattedHTMLMessage
                id="enroll_form.enrolled.processed_by"
                values={{
                  year: plan.contract_year,
                  planName: plan.name,
                  planId: makePlanDisplayId(plan),
                  confirmationNumber: enrollData.confirmationNumber,
                  beneficiaryName: `${enrollData.firstName} ${enrollData.lastName}`.toLowerCase(),
                }}
              />
            </div>

            <div className="EnrolledContact">
              <span className="EnrolledContact__heading">
                {t("enroll_form.enrolled.contact_directly")}
              </span>
              <span>{plan.name}</span>
              <address className="ds-u-font-style--normal">
                {plan.address_1}
                <br />
                {plan.address_2 && (
                  <>
                    {plan.address_2}
                    <br />
                  </>
                )}
                {plan.city}, {plan.state} {plan.zipcode}
              </address>

              {plan.member_phone && (
                <span>
                  {t("phone")}:{` `}
                  <a href={`tel:${plan.member_phone.number}`}>
                    {plan.member_phone.number}
                  </a>
                </span>
              )}
              <span>
                {t("website")}:{` `}
                <a
                  href={addProtocolToUrl(plan.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {addProtocolToUrl(plan.url)}
                </a>
              </span>
              <Button
                className="EnrolledContact__printButton"
                size="small"
                onClick={(): void => {
                  /* istanbul ignore next: tested elsewhere */
                  printPage();
                }}
              >
                {t("app.terms.print_your_application")}
              </Button>
            </div>

            {viewMedigap && (
              <div className="ds-u-padding--3 ds-u-margin-top--3 ds-u-fill--gray-lightest">
                <h3>{t("enroll_form.also_chosen_medigap")}</h3>
                <a
                  className="ds-c-button ds-c-button--primary"
                  href={`#${routes.medigap.landingPage}?lang=${language}`}
                  onClick={(): void => {
                    // istanbul ignore next: tested elsewhere
                    sendTealiumEvent("Plan Enroll", "Going to Medigap");
                  }}
                >
                  {t("landing_page.coverage_selection.view_policies")}
                </a>
              </div>
            )}
          </section>
        )}

        <section className="EnrolledDetails">
          <FormattedHTMLMessage id="enroll_form.enrolled.details" tagName="p" />
        </section>
        <a
          href={C.linkToMedicareHome(language)}
          className="ds-c-button ds-c-button--primary"
        >
          {t("done")}
        </a>
      </div>
    </div>
  );
};

export default Enrolled;
